import React from "react";
import * as CONSTANTS from "../../utilities/Constants";
import { Dropdown, DropdownOption } from "@abb/abb-common-ux-react";
import AbbDashboardTableComponent from "./DashboardTable";
import Events from "./Events";
import { Translation } from "react-i18next";
import moment from "moment";

interface ILandingProps {
}

interface ILandingState {
  date: string
}

export default class Landing extends React.Component<ILandingProps, ILandingState> {
  private _mount: boolean = false;
  private _messages: string[];

  constructor(props: {}) {
    super(props)
    this._mount = true;
    this.state = {
      date: moment(new Date()).format("DD/MM/YYYY")
    };
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;
  }

  public render() {
    return (
      <Translation>
        {
          t =>
          <React.Fragment>
                            <div className="page-scroll">
                                <div className="dashboard-layout-container">
                                    
                                <div className="dashboard-container-box align-self-center rounded-sm rounded-lg submit-header-fixed">
                                    <div className="col-12">
                                        <div className="float-left">
                                            <Dropdown
                                                    label={t(CONSTANTS.LABLE_INSTRUMENT_STATION)}
                                                    allowAdd={false}
                                                    clearable={false}
                                                    placeholder={"Station A"}
                                                    >
                                                    <DropdownOption key={1} label={"Station A"} value={"Station A"} />
                                            </Dropdown>
                                        </div>
                                        <div className="float-right row">
                                        <span className="summary-label">
                                            {this.state.date}
                                        </span>
                                        </div>
                                    </div>
                                </div>

                                    <div>
                                        <div className="col-12 dashboard-no-padding float-left">
                                            <div className="dashboard-box-1">
                                                <div className="w-100">
                                                <AbbDashboardTableComponent
                                                    columns={[
                                                      {
                                                        dataField: "instrument",
                                                        text: t(CONSTANTS.INSTRUMENT),
                                                      },
                                                      {
                                                        dataField: "status",
                                                        text: t(CONSTANTS.STATUS),
                                                      },
                                                      {
                                                        dataField: "currentlyMeasuring",
                                                        text: t(CONSTANTS.CURRENTLY_MEASURING),
                                                      },
                                                      {
                                                        dataField: "totalCounts",
                                                        text: t(CONSTANTS.TOTAL_COUNTS),
                                                      },
                                                      {
                                                        dataField: "approvedSample",
                                                        text: t(CONSTANTS.APPROVED_SAMPLE),
                                                      },
                                                      {
                                                        dataField: "rejectedSample",
                                                        text: t(CONSTANTS.REJECTED_SAMPLES),
                                                      },
                                                      {
                                                        dataField: "upcomingEvents",
                                                        text: t(CONSTANTS.UPCOMING_EVENTS),
                                                      },
                                                      
                                                    ]}
                                                    list={
                                                      [
                                                          { "instrument": "Instrument 1", "status": "In Use", "currentlyMeasuring": "Sample 123", "totalCounts": "1208", "approvedSample": "321", "rejectedSample": "65", "upcomingEvents": "Maintenance" },
                                                          { "instrument": "Instrument 2", "status": "In Use", "currentlyMeasuring": "Sample 124", "totalCounts": "234", "approvedSample": "123", "rejectedSample": "46", "upcomingEvents": "Callibration" },
                                                          { "instrument": "Instrument 3", "status": "In Use", "currentlyMeasuring": "Sample 125", "totalCounts": "543", "approvedSample": "421", "rejectedSample": "132", "upcomingEvents": "Maintenance" },
                                                          { "instrument": "Instrument 4", "status": "In Use", "currentlyMeasuring": "Sample 126", "totalCounts": "756", "approvedSample": "743", "rejectedSample": "52", "upcomingEvents": "Maintenance" },
                                                        	{ "instrument": "Instrument 5", "status": "Available", "currentlyMeasuring": "--", "totalCounts": "783", "approvedSample": "423", "rejectedSample": "108", "upcomingEvents": "Callibration" }
                                                        ]
                                                    }
                                                    select={false}
                                                    isFixedColumn={false}
                                                    isEditable={false}
                                                    isTitle={<div><p className="sidebar-main-title-dashboard" style={{marginBottom: "0.25rem"}}>{t(CONSTANTS.INSTRUMENT_TITLE)}</p></div>}
                                                  />
                                                </div>
                                            </div>
                                        </div>
                                    </div> 

                                </div>
                               </div> 
            </React.Fragment>
        }
      </Translation>
    );
  }
}
